import { setupi18n } from "./LocalizationContext";
import enLang from "./en.json";

export function setupLocalization() {
    setupi18n([{ language: "en", translation: enLang }], "en");
}
